import { render, staticRenderFns } from "./written-test.vue?vue&type=template&id=3299a6e5&scoped=true&"
import script from "./written-test.vue?vue&type=script&lang=js&"
export * from "./written-test.vue?vue&type=script&lang=js&"
import style0 from "./written-test.vue?vue&type=style&index=0&id=3299a6e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3299a6e5",
  null
  
)

export default component.exports